import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { userLogin } from '../actions/index';
import apiPath from '../constants/apiPath';

export default function WaCheckout() {
    const { token }   = useParams();
    const navigate    = useNavigate();
    const dispatch    = useDispatch();
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!token) {
            setError('Invalid checkout link.');
            return;
        }

        const resolve = async () => {
            try {
                const res = await fetch(apiPath.baseURL + apiPath.waCheckoutResolve + token, {
                    headers: { Accept: 'application/json' },
                });
                const json = await res.json();

                if (!json.status || !json.data?.token) {
                    setError(json.error || 'This checkout link is invalid or has already been used.');
                    return;
                }

                // Log in the user with the one-time Passport token
                dispatch(userLogin(json.data));

                // Redirect straight into delivery checkout
                navigate('/checkout/delivery', { replace: true });
            } catch {
                setError('Something went wrong. Please try again or contact support.');
            }
        };

        resolve();
    }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!error) {
        return (
            <div style={styles.container}>
                <div style={styles.spinner} />
                <p style={styles.text}>Preparing your cart, please wait…</p>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            <p style={{ fontSize: 40, margin: 0 }}>⚠️</p>
            <p style={styles.error}>{error}</p>
            <a href="/" style={styles.link}>Go to homepage</a>
        </div>
    );
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        fontFamily: 'sans-serif',
        padding: '40px 20px',
        textAlign: 'center',
        gap: 16,
    },
    spinner: {
        width: 40,
        height: 40,
        border: '4px solid #e0e0e0',
        borderTop: '4px solid #c8973c',
        borderRadius: '50%',
        animation: 'wa-spin 0.8s linear infinite',
    },
    text: {
        color: '#555',
        fontSize: 16,
        margin: 0,
    },
    error: {
        color: '#c0392b',
        fontSize: 16,
        maxWidth: 400,
        margin: 0,
    },
    link: {
        color: '#c8973c',
        textDecoration: 'none',
        fontWeight: 600,
    },
};

// Inject keyframe once
if (typeof document !== 'undefined' && !document.getElementById('wa-spin-style')) {
    const s = document.createElement('style');
    s.id = 'wa-spin-style';
    s.textContent = '@keyframes wa-spin { to { transform: rotate(360deg); } }';
    document.head.appendChild(s);
}
